import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import maxBy from 'lodash/maxBy';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';

import SRLKeyNumber from '../SRLKeyNumber/SRLKeyNumber';

import { CHART_HEIGHT, CHART_FULL_HEIGHT } from './helper';

const ChartGraph = (chartData, height) => {
  let highDomainLimit = 40;
  const maxData = maxBy(chartData, 'studentCount');
  if (maxData) {
    highDomainLimit = Number(maxData.studentCount);
  }

  return (
    <ResponsiveContainer height={height}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 6, left: -20, bottom: 0 }}
      >
        <Bar
          dataKey="studentCount"
          fill="var(--prs-c-info-800)"
          minPointSize={0}
          label={{
            value: 'studentCount',
            position: 'top',
            fontFamily: 'Source Sans Pro',
            fontSize: 14,
            fill: '#242424'
          }}
        />
        <XAxis
          dataKey="label"
          tickLine={false}
          angle={45}
          tickMargin={15}
          interval={0}
          tick={{
            fontSize: '14',
            dx: 4,
          }}
          height={42}
        />
        <YAxis
          dataKey="studentCount"
          domain={[0, highDomainLimit]}
          label={{ value: 'total students',
            angle: -90,
            position: 'center',
            fontSize: 14,
            fontFamily: 'Source Sans Pro',
            fontStyle: 'italic',
            fill: '#242424',
          }}
          tick={false}
          axisLine={false}
          tickLine={false}
        />
        <CartesianGrid vertical={false} horizontal={false} />
      </BarChart>
    </ResponsiveContainer>
  );
};

function LowerAverageAndGradesChart({ chartData = [], lowerThanExpectedPercentage = {} }) {
  const isLowerThanExpectedPercentageEmpty = isEmpty(lowerThanExpectedPercentage);
  const isChartDataEmpty = chartData.length === 0;
  if (isChartDataEmpty && isLowerThanExpectedPercentageEmpty) {
    return null;
  }

  const chartHeight = isLowerThanExpectedPercentageEmpty ? CHART_FULL_HEIGHT : CHART_HEIGHT;

  return (
    <div>
      {!isLowerThanExpectedPercentageEmpty ? (
        <SRLKeyNumber
          keyNumber={parseInt(+lowerThanExpectedPercentage.percent, 10)}
          postScript="%"
          label={(
            <span>{lowerThanExpectedPercentage.label}{lowerThanExpectedPercentage.customLabel && <span><b>{` ${lowerThanExpectedPercentage.customLabel}`}</b></span>}</span>
          )}
          smallFontSize
        />
      ) : null}

      {!isChartDataEmpty ? ChartGraph(chartData, chartHeight) : null}
    </div>
  );
}

LowerAverageAndGradesChart.propTypes = {
  lowerThanExpectedPercentage: PropTypes.object,
  chartData: PropTypes.array.isRequired,
};

export default LowerAverageAndGradesChart;
